import React, { useEffect, useState } from "react";
import { CloseButton } from "react-bootstrap";
import { useMeeQuery, useTeamsQuery } from "../../../Services/settingsAPIs/CommonAPI";
import { useUsersByTeamIdQuery } from "../../../Services/ticket/users/UsersByTeamId";
import { toast } from "react-toastify";
import { useUpdateUsernameMutation } from "../../../Services/ticket/TicketDetail";
import { useParams } from "react-router-dom";
import { useTicketControlQuery } from "../../../Services/ticketAccessControl/TicketAccessControl";
import { USER_TEAM_ID } from "../../../constants";
import { Loader } from "react-bootstrap-typeahead";
import { useAddUserNameMutation } from "../../../Services/email/EmailInbox";
import { useUpdateCamapignUsernameMutation } from "../../../Services/campign/CampaignDetail";

interface IProps {
  closeModal: () => void;
  refetch: any;
  refetchAuditTrailForwardedData?: any
  userChangeType?: string
  statusType?: string
  refetchEmailTrail:any
}

const ChangeUserModal: React.FC<IProps> = ({ closeModal, refetch, refetchAuditTrailForwardedData, userChangeType, statusType ,refetchEmailTrail}) => {
  const [selectedTeams, setSelectedTeams] = useState([]);
  const teamId = localStorage.getItem(USER_TEAM_ID);

  const [theTeams, setTheTeams] = useState([]);
  const [isCheckboxEnabled, setIsCheckboxEnabled] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

  const { data: teamsData } = useTicketControlQuery(teamId);
  const { data: teamsDataa } = useTeamsQuery({});
  const [selectedUser, setSelectedUser] = useState("");
  const [theUser, setTheUser] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isUserLoading, setIsUserLoading] = useState(false);



  const { data: usersData, status: usersStatus } = useUsersByTeamIdQuery(
    selectedTeams,
    {
      skip: !selectedTeams,
    }
  );
  const { data } = useMeeQuery({});

  const params = useParams();
  const uuid = params.uuid;
  // Ticket
  const [UpdateUsername] = useUpdateUsernameMutation();
  // Email
  const [addAssigne] = useAddUserNameMutation();
  // Lead
  const [UpdateLeadUsername] = useUpdateCamapignUsernameMutation();

  useEffect(() => {
    if (data && (userChangeType === "Email" || userChangeType === "Lead")) {
      return setTheTeams(data?.teams);
    }

    if (teamsData?.length > 0) {
      return setTheTeams(teamsData[0]?.team);
    } else {
      return setTheTeams(teamsDataa);
    }
  }, [teamsData, teamsDataa, data]);

  useEffect(() => {
    if (usersData) {
      setTheUser(usersData);
    }
  }, [usersData]);

  useEffect(() => {
    if (usersStatus === "pending") {
      setIsUserLoading(true);
    } else {
      setIsUserLoading(false);
    }
  }, [usersStatus]);

  useEffect(() => {
    setIsCheckboxEnabled(selectedTeams.length > 0);
    if (selectedTeams.length === 0) {
      setIsCheckboxChecked(false);
    }
  }, [selectedTeams]);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      let response;

      if (userChangeType === "Email") {
        try {
          response = await addAssigne({
            body: {
              assignee: String(selectedUser),
              team: String(selectedTeams),
            },
            setectedEmailId: uuid,
          });
        } catch (err) {
          throw new Error("Failed to assign by email");
        }
      }

      if (userChangeType === "Ticket") {
        try {
          response = await UpdateUsername({
            id: `${uuid}`,
            assignee: selectedUser,
            team_assignee: selectedTeams,
          });
        } catch (err) {
          throw new Error("Failed to assign by ticket");
        }
      }
      if (userChangeType === "Lead") {
        try {
          response = await UpdateLeadUsername({
            id: `${uuid}`,
            new_assignee: selectedUser,
            assigned_by: localStorage.getItem("circleone-username"),
            status_type: statusType,
            dynamic_fields: {},
            static_fields: {}
          });
        } catch (err) {
          throw new Error("Failed to assign by lead");
        }
      }

      if (response?.data) {
        toast.success("Assigned successfully!");
        closeModal();
        refetch();

        refetchAuditTrailForwardedData?.();
      } else if (response?.error) {
        const { status, data }: any = response.error;

        if (data?.detail) {
          data.detail.forEach((message) => {
            toast.error(` ${message}`);
          });
        } else {
          toast.error(`Error ${status}: Something went wrong. Please try again.`);
        }
      }
    } catch (error) {
      toast.error("Failed to assign. Please try again.");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <>
      <div className="text-end">
        <CloseButton onClick={closeModal} />
      </div>

      <div className="row mt-3">
        <div className="col">
          <label className="form-label">Team</label>
          <select
            className="form-select"
            value={selectedTeams}
            onChange={(e: any) => {
              setSelectedTeams(e.target.value);
              setIsCheckboxChecked(false);
              setSelectedUser("");

            }}
          >
            <option value="">Select Team</option>
            {theTeams.map((team: any) => (
              <option key={team.id} value={team.id}>
                {team.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="row mt-5">
        <div className="col">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              disabled={!isCheckboxEnabled}
              checked={isCheckboxChecked}
              onChange={(e) => setIsCheckboxChecked(e.target.checked)}
            />
            <label htmlFor="assignToUserCheckbox" className="form-check-label">
              Assign to user
            </label>
          </div>
        </div>
      </div>

      {isCheckboxChecked && (
        <div className="row mt-3">
          <div className="col">
            <label className="form-label">User</label>
            {isUserLoading ? (
              <Loader />
            ) : (
              <select
                className="form-select"
                value={selectedUser}
                onChange={(e) => setSelectedUser(e.target.value)}
              >
                <option value="" disabled>
                  Select User
                </option>
                {theUser.map((user: any) => (
                  <option key={user.id} value={user.id}>
                    {user.username.split("@")[0]}
                  </option>
                ))}
              </select>
            )}
          </div>
        </div>
      )}
      <div className="row text-end ">
        <div className="col">
          <button className="btn btn-primary mt-5" onClick={handleSubmit}>
            {isLoading ? (
              <>
                Assigning... <Loader />
              </>
            ) : (
              "Assign"
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default ChangeUserModal;
